import React from "react";

export const useConcesionadosOptions = () => {
  const [concesionadosOptions] = React.useState([
    { value: null, label: "Todos" },
    { value: 1, label: "Sin Concesionados" },
    { value: 2, label: "Solo Concesionados" }
  ]);

  return { concesionadosOptions };
};